import { BookingTypeEnum, IQuote, QuoteStatusEnum } from '@cai-services';
import { cloneDeep, omit } from 'lodash';
import { Forwarder, QuoteRequest } from '../core';

export class QuoteUtil {
  // copied from API Core
  static isBooking(quote: IQuote): boolean {
    const bookingStatuses = [
      QuoteStatusEnum.BOOKING_REJECTED,
      QuoteStatusEnum.CANCELLED,
      QuoteStatusEnum.CANCELLATION_REQUESTED,
      QuoteStatusEnum.PENDING_AIRLINE_INFORMATION,
      QuoteStatusEnum.PENDING_DELIVERY,
      QuoteStatusEnum.IN_TRANSIT,
      QuoteStatusEnum.AT_DESTINATION,
      QuoteStatusEnum.DELIVERED,
      QuoteStatusEnum.PENDING_BOOKING_MODIFY,
    ];

    return bookingStatuses.includes(quote.quoteStatus);
  }

  static isOption(quote: IQuote): boolean {
    const optionStatuses = [
      QuoteStatusEnum.OPTION_REQUESTED,
      QuoteStatusEnum.OPTION_PLACED,
      QuoteStatusEnum.PENDING_OPTION_MODIFY,
      QuoteStatusEnum.OPTION_CANCELLED,
      QuoteStatusEnum.OPTION_REJECTED,
    ];

    return optionStatuses.includes(quote.quoteStatus);
  }

  static isQuoteQuantum(quote): boolean {
    return (
      quote?.quoteRequest?.quoteQuantum != null ||
      quote?.quoteRequest?.bookingType === BookingTypeEnum.QUANTUM_QUOTE
    );
  }

  static isQuoteRequestQuantum(quoteRequest): boolean {
    return (
      quoteRequest?.quoteQuantum != null ||
      quoteRequest?.bookingType === BookingTypeEnum.QUANTUM_QUOTE
    );
  }

  /**
   * Minifies a QuoteRequest object by removing specific properties.
   * @param quoteRequest The QuoteRequest object to minify.
   * @returns A new QuoteRequest object with specific properties removed.
   * @throws {Error} If the input quoteRequest is null or undefined.
   */
  static minifyQuoteRequest(quoteRequest: QuoteRequest): QuoteRequest {
    if (!quoteRequest) {
      throw new Error('Input quoteRequest cannot be null or undefined');
    }

    const minified = cloneDeep(quoteRequest);
    minified.quotes.forEach((quote) => (quote.quoteRequest = undefined));
    minified.commodities.forEach(
      (commodity) => (commodity.childrens = undefined),
    );

    if (minified.forwarder) {
      minified.forwarder = omit(minified.forwarder, [
        'activatedFeatures',
        'officeAccesses',
      ]) as Forwarder;
    }

    if (minified.forwarderCreator) {
      minified.forwarderCreator = omit(minified.forwarderCreator, [
        'activatedFeatures',
        'officeAccesses',
      ]) as Forwarder;
    }

    return minified;
  }
}
